module.exports = __webpack_public_path__ + "static/media/product-4.f2855f28.png";